import { useEffect, RefObject } from "react";

/**
 * While `open`, dismiss when the user clicks outside `ref` or presses Escape.
 * Shared by the composer attach/model menus and the sidebar kebab menu.
 */
export const useDismiss = (
	open: boolean,
	ref: RefObject<HTMLElement | null>,
	onDismiss: () => void
): void => {
	useEffect(() => {
		if (!open) return;
		const onDoc = (e: MouseEvent) => {
			if (ref.current && !ref.current.contains(e.target as Node)) onDismiss();
		};
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onDismiss();
		};
		document.addEventListener("mousedown", onDoc);
		document.addEventListener("keydown", onKey);
		return () => {
			document.removeEventListener("mousedown", onDoc);
			document.removeEventListener("keydown", onKey);
		};
	}, [open, ref, onDismiss]);
};
